import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import {getBowserState} from '@epic-core/common';

export default class AtvImg extends React.Component {
    static propTypes = {
        layers: PropTypes.arrayOf(PropTypes.string),
        isStatic: PropTypes.bool,
        className: PropTypes.string,
        url: PropTypes.string
    };

    state = {
        rootElemWidth: 0,
        rootElemHeight: 0,
        isOnHover: false,
        container: {},
        shine: {},
        layers: []
    };

    componentDidMount = () => {
        if (!this.props.isStatic) {
            this.setState({
                rootElemWidth:
                    this.node.clientWidth || this.node.offsetWidth || this.node.scrollWidth,
                rootElemHeight:
                    this.node.clientHeight || this.node.offsetHeight || this.node.scrollHeight
            });
        }
    };

    handleMove = ({pageX, pageY}) => {
        const layerCount = this.props.layers.length;
        const {rootElemWidth, rootElemHeight} = this.state;
        const bodyScrollTop =
            root.document.body.scrollTop || root.document.getElementsByTagName('html')[0].scrollTop;
        const bodyScrollLeft = root.document.body.scrollLeft;
        const offsets = this.node.getBoundingClientRect();
        const wMultiple = 320 / rootElemWidth;
        const offsetX = 0.52 - (pageX - offsets.left - bodyScrollLeft) / rootElemWidth;
        const offsetY = 0.52 - (pageY - offsets.top - bodyScrollTop) / rootElemHeight;
        const dy = pageY - offsets.top - bodyScrollTop - rootElemHeight / 2;
        const dx = pageX - offsets.left - bodyScrollLeft - rootElemWidth / 2;
        const yRotate = (offsetX - dx) * (0.07 * wMultiple);
        const xRotate = (dy - offsetY) * (0.1 * wMultiple);
        const arad = Math.atan2(dy, dx);
        const rawAngle = (arad * 180) / Math.PI - 90;
        const angle = rawAngle < 0 ? rawAngle + 360 : rawAngle;

        this.setState({
            container: {
                transform: `rotateX(${xRotate}deg) rotateY(${yRotate}deg) ${
                    this.state.isOnHover ? ' scale3d(1.07,1.07,1.07)' : ''
                }`
            },
            shine: {
                background: `linear-gradient(${angle}deg, rgba(255, 255, 255, ${(pageY -
                    offsets.top -
                    bodyScrollTop) /
                    (rootElemHeight * 0.4)}) 0%, rgba(255, 255, 255, 0) 80%)`,
                transform: `translateX(${offsetX * layerCount - 0.1}px) translateY(${offsetY *
                    layerCount -
                    0.1}px)`
            },
            layers: {
                transform: `translateX(${offsetX *
                    layerCount *
                    (2.5 / wMultiple)}px) translateY(${offsetY * layerCount * (2.5 / wMultiple)}px)`
            }
        });
    };

    handleTouchMove = evt => {
        const url = this.props.url;
        if (url) return;

        const {mobile, tablet} = getBowserState();
        if (mobile || tablet) return;

        evt.preventDefault();
        const {pageX, pageY} = evt.touches[0];
        this.handleMove({pageX, pageY});
    };

    handleEnter = () => {
        this.setState({isOnHover: true});
    };

    handleLeave = () => {
        this.setState({
            isOnHover: false,
            container: {},
            shine: {},
            layers: []
        });
    };

    onClick = e => {
        e.preventDefault();
        const url = this.props.url;
        if (url) {
            root.open(url, '_blank');
        }
    };

    renderLayers = () => (
        <div className="paragon-card-layers">
            {this.props.layers &&
                this.props.layers.map((imgSrc, idx) => {
                    const layerIndex = idx;
                    return (
                        <div
                            style={{
                                backgroundImage: `url(${imgSrc || ''})`,
                                ...(this.state.layers[idx] ? this.state.layers[idx] : {})
                            }}
                            className="paragon-card-rendered-layer"
                            key={`layer-${layerIndex}`}
                        />
                    );
                })}
        </div>
    );

    render() {
        const url = this.props.url;
        const clickable = !!url;
        const {mobile, tablet} = getBowserState();

        const disabled = mobile || tablet;

        return (
            <div
                role="menuitem"
                tabIndex={0}
                style={{transform: `perspective(${this.state.rootElemWidth * 3}px)`}}
                onMouseMove={this.handleMove}
                onMouseEnter={this.handleEnter}
                onMouseLeave={this.handleLeave}
                onClick={this.onClick}
                className={`${this.props.className || ''} ${clickable ? 'clickable' : ''} ${
                    disabled ? 'anim-disabled' : ''
                }`}
                ref={node => {
                    this.node = node;
                }}>
                <div className="paragon-card-container" style={{...this.state.container}}>
                    <div className="paragon-card-shadow" />
                    <div className="paragon-card-shine" style={{...this.state.shine}} />
                    {this.renderLayers()}
                </div>
            </div>
        );
    }
}
